module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('article', {
    ref: "item",
    staticClass: "slide-content"
  }, [_c('aside', {
    ref: "media",
    staticClass: "slide-media"
  }, [(_vm.isTable) ? _c('img', {
    staticClass: "slide-media__image",
    attrs: {
      "src": _vm.image,
      "alt": "image"
    }
  }) : _c('div', {
    ref: "canvas",
    staticClass: "slide-media__canvas"
  })]), _c('main', {
    staticClass: "slide-main"
  }, [_c('h3', {
    ref: "title",
    staticClass: "slide-main__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    ref: "text",
    staticClass: "slide-main__text"
  }, [_vm._v(_vm._s(_vm.text))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4e7476","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/regular-slide.vue
// module id = 478
// module chunks = 0